module.exports = __webpack_public_path__ + "img/rku10-char-4.d59345f5.png";